module.exports = __webpack_public_path__ + "static/img/f-icon021.b4f80ad.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/f-icon021.png
// module id = B5Hm
// module chunks = 10